export default __webpack_public_path__ + "static/media/order-status_ok.0d50e199.svg";